export const SORT = "sort";
export const KEY = "key";
export const ASC = "asc";
export const DESC = "desc";
export const PAGE = "page";
export const VISIBLE = "visible";
